// Browser auto-translate (Chrome/Edge/Safari) swaps React-managed text nodes for its
// own <font> wrappers. React then calls removeChild/insertBefore on nodes that are no
// longer where it left them, the DOM throws NotFoundError mid-commit, and React unmounts
// up to the nearest error boundary. We have real users who translate the app because we don't ship
// their language, so blocking translation with translate="no" would lock them out.
// Instead, make the two calls tolerate a moved node: the translated text may go stale,
// but the app keeps working. Workaround from facebook/react#11538.
export function installTranslateGuard() {
  if (typeof Node !== 'function' || !Node.prototype) return

  const originalRemoveChild = Node.prototype.removeChild
  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
    if (child.parentNode !== this) {
      console.warn('[translateGuard] removeChild on a node with a different parent', child)
      return child
    }
    return originalRemoveChild.call(this, child) as T
  }

  const originalInsertBefore = Node.prototype.insertBefore
  Node.prototype.insertBefore = function <T extends Node>(
    this: Node,
    newNode: T,
    referenceNode: Node | null,
  ): T {
    if (referenceNode && referenceNode.parentNode !== this) {
      console.warn('[translateGuard] insertBefore with a reference node from another parent')
      return newNode
    }
    return originalInsertBefore.call(this, newNode, referenceNode) as T
  }
}
